<template>
  <section>
    <gs-header title="Quản lý vùng miền">
      <router-link :to="{ name: 'create-region' }" class="ui mini blue button"><i class="fa fa-plus"></i> Thêm
        mới</router-link>
    </gs-header>
    <div class="padding-sm-all">
      <gs-table :ref="regionTable" :table-name="regionTable" data-source="regions" :data-params="filters"
        :data-sorted="sorted" :data-sorts="sorts" @remove-filter="removeFilter">
        <section slot="filters">

        </section>
        <template slot-scope="datas">
          <el-table :data="datas.data" border :row-class-name="tableRowClassName" style="width: 100%">
            >
            <el-table-column label="#" width="80">
              <template slot-scope="scope">
                <small v-if="dataPaginations[regionTable]">{{ (scope.$index + 1) +
                  ((dataPaginations[regionTable].current_page - 1) * dataPaginations[regionTable].per_page) }}</small>
              </template>
            </el-table-column>

            <!-- <el-table-column
              label="Vùng Miền"
              width="150"
            >
              <template slot-scope="scope">
                <p><span class="shipment-code-display">{{scope.row.id}}</span></p>
              </template>
            </el-table-column> -->

            <el-table-column label="Tên">
              <template slot-scope="scope">
                <p>{{ scope.row.name }}</p>
              </template>
            </el-table-column>

            <el-table-column label="Tên Viết Tắt">
              <template slot-scope="scope">
                <p>{{ scope.row.short_name }}</p>
              </template>
            </el-table-column>

            <el-table-column width="95">
              <template slot-scope="scope">
                <section class="padding-sm-top padding-sm-bottom">
                  <el-tooltip placement="top" content="Chi tiết" class="display-inline" v-if="!scope.row.deleted_at">
                    <a @click.prevent="detailRegion(scope.row)"
                      class="text-blue padding-all display-inline-block cursor-pointer"><i class="fa fa-search"></i></a>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Sửa" class="display-inline" v-if="!scope.row.deleted_at">
                    <router-link class="text-orange padding-all display-inline-block"
                      :to="{ name: 'edit-region', params: { id: scope.row.id } }"><i class="fa fa-pencil-square-o"
                        aria-hidden="true"></i></router-link>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Xóa" class="display-inline" v-if="!scope.row.deleted_at">
                    <a @click.prevent="deleteRegion(scope.row)"
                      class="text-red padding-all display-inline-block cursor-pointer"><i class="fa fa-trash"></i></a>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Khôi phục" class="display-inline" v-if="scope.row.deleted_at">
                    <a class="text-blue padding-all display-inline-block cursor-pointer" @click="restore(scope.row)"><i
                        class="fa fa-refresh" aria-hidden="true"></i></a>
                  </el-tooltip>
                </section>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </gs-table>
      <el-dialog :title="'Chi tiết vùng miền: ' + region.name" :visible.sync="detailModal">
        <el-table v-if="region.cities" :data="region.cities.data">
          <el-table-column type="index" width="50">
          </el-table-column>
          <el-table-column property="name" label="Tên">
          </el-table-column>
        </el-table>
      </el-dialog>
    </div>
  </section>
</template>

<script>
import { deleteRegion, restoreRegion } from 'src/api/regions'
import { debounce } from 'lodash'
import ls from 'local-storage'
import { mapGetters, mapActions } from 'vuex'
export default {

  name: 'Region',

  data() {
    return {
      regionTable: 'regions',
      filters: {
        sort: 'created_at:-1'
      },
      sorted: {
        created_at: -1
      },
      sorts: [
        { key: 'created_at', name: 'Ngày tạo' }
      ],
      detailModal: false
    }
  },
  computed: {
    ...mapGetters('region', ['region'])
  },
  methods: {
    ...mapActions('region', ['getRegion', 'setRegion']),
    removeFilter() {
      this.reloadGsTable(this.regionTable)
      this.filters = {
        sort: 'created_at:-1'
      }
    },
    filter: debounce(function () {
      let lsFilter = ls.get('filters', {})
      if (!lsFilter) {
        lsFilter = {}
      }
      lsFilter[this.regionTable] = this.filters
      ls.set('filters', lsFilter)
      if (ls.get('doFilter')) {
        this.reloadGsTable(this.regionTable)
      }
    }, 300),
    deleteRegion(region) {
      this.setRegion(region)
      this.$confirm(`Bạn chắc chắn muốn xóa vùng miền ${this.region.name}`, 'Xóa vùng miền', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        this.delRegion()
      }).catch(() => {

      })
    },
    delRegion() {
      deleteRegion(this.region.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Xóa vùng miền thành công'
          })
          this.reloadGsTable(this.regionTable)
        } else {
          this.$message({
            type: 'danger',
            message: 'Xóa vùng miền thất bại'
          })
        }
      })
    },
    detailRegion(region) {
      this.detailModal = true
      this.getRegion({ id: region.id, params: { include: 'cities' } })
    },
    tableRowClassName(row) {
      if (row.deleted_at) {
        return 'row-orange'
      }
      return null
    },
    restore(region) {
      this.setRegion(region)
      this.$confirm(`Bạn chắc chắn muốn khôi phục vùng miền ${this.region.name}`, 'Khôi phục vùng miền', {
        confirmButtonText: 'Khôi phục',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        this.resRegion()
      }).catch(() => {

      })
    },
    resRegion() {
      restoreRegion(this.region.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Khôi phục vùng miền thành công'
          })
          this.reloadGsTable(this.regionTable)
        } else {
          this.$message({
            type: 'error',
            message: 'Khôi phục vùng miền thất bại'
          })
        }
      })
    }
  },
  mounted() {
    if (ls.get('filters') && ls.get('filters')[this.regionTable]) {
      this.filters = ls.get('filters')[this.regionTable]
      setTimeout(() => {
        ls.set('doFilter', true)
      }, 100)
    }
    this.listenReloadGsTable()
    this.sorted = this.getSorted(this.regionTable)
  },
  beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      ls.remove('filters')
      ls.set('doFilter', true)
    } else {
      if (ls.get('filters') && ls.get('filters')['regions']) {
        ls.set('doFilter', false)
      } else {
        ls.set('doFilter', true)
      }
    }
    next()
  }
}
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// Region.vue?0e6756aa